import { render, staticRenderFns } from "./vehicleDetailForm.vue?vue&type=template&id=4ee010bb&scoped=true&"
import script from "./vehicleDetailForm.vue?vue&type=script&lang=js&"
export * from "./vehicleDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee010bb",
  null
  
)

export default component.exports